import React, { Component } from 'react';
import FileUpload from '../FileUpload/FileUpload';

class PicUpload extends React.Component {
     constructor(props) {
        super(props);
    }

    render() {
        let picUp = true;
            return (
                <FileUpload
                    picUp={picUp}
                    {...this.props}
                />
            );
    }

}


export default PicUpload;



// WEBPACK FOOTER //
// ./src/components/Field_Components/PicUpload/PicUpload.js